import { Dropdown } from "flowbite-react";
import { useDispatch, useSelector } from "react-redux";
import { switchWorkspace } from "../../../../services/auth/auth.service";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import useUserRole from "../../../../hooks/useUserRole";
import { _userRole } from "../../../../utils/common";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { _logoutUser } from "../../../../store/actions/user";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { useState } from "react";


export const getPseudoDeviceId = () => {
  const data = navigator.userAgent + navigator.platform;
  let hash = 0;
  for (let i = 0; i < data.length; i++) {
    const char = data.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0; 
  }
  return Math.abs(hash).toString(16); 
};

export function WorkspaceDropdown({ label, trigger, dropdownData }) {
  const userInfo = useSelector((state) => state?.user?.userInfo);
  const user = userInfo?.user || { name: "User" };
  const dispatch = useDispatch();
  // Since we removed workspace slice, provide a fallback
  const workspaceInfo = {
    workspaces: [],
    permissions: [],
    default_workspace: {
      id: 1,
      name: "School"
    }
  };
  const [loading, setLoading] = useState(false);
  const { workspaces, permissions } = workspaceInfo;
  const role = useUserRole();
  const navigate = useNavigate();



  const handleLogout = () => {
    setLoading(true);
    const device_id = getPseudoDeviceId();
    dispatch(_logoutUser({ device_id }, (error, response) => {
      setLoading(false);
      if (error) {
        return toast.error("Failed to logout!");
      }
      navigate("/auth/login");
    }));
  };

  const handleClick = () => {
    navigate("/configuration");
  }

  const handleChangePassword = () => {
    navigate("/change-password");
  };

  const handleSwitch = (workspace_id) => {
    if (workspace_id !== workspaceInfo.default_workspace.id) {
      switchWorkspace({ workspace_id })
        .then((response) => {
          toast.success("Workspace switched successfully!");
          setTimeout(() => window.location.reload(), 800);
        })
        .catch((error) => {
          toast.error(
            "Failed to switch workspace! " + error.response.data?.message
          );
          console.error(error);
        });
    }
  };

  return (
    <Dropdown
      label={label ? label : ""}
      className={
        "hover:border border border-gray-100 md:w-[350px] w-[330px] bg-white pb-0 shadow-custom rounded-md md:ml-14 z-30"
      }
      renderTrigger={() => trigger}
      dismissOnClick={true}
      placement="bottom-center"
    >
      <div className={"flex flex-col max-h-96 overflow-y-hidden"}>
        <div className={`border-b-2 border-borderColor`}>
          {workspaces.map((workspace, index) => {
            const firstTwoChars = workspace?.name?.slice(0, 2).toUpperCase() || "N/A";
            return (
              <Dropdown.Item
                className="hover:bg-transparent focus:bg-transparent hover:rounded-md text-theme"
                key={index}
              >
                <div
                  className={
                    "flex justify-between items-center w-full cursor-pointer hover:bg-none gap-2 p-2 hover:shadow-custom"
                  }
                  onClick={() => handleSwitch(workspace.id)}
                >
                  <div className={"flex items-center gap-2 cursor-pointer"}>
                    <div
                      className={
                        "w-12 h-12 rounded-md bg-gradient-to-r from-[#1E3A8A] to-[#3B82F6] flexCenter text-white"
                      }
                    >
                      {firstTwoChars}
                    </div>
                    <div className={"flex flex-col justify-center items-start"}>
                      <span className="font-bold text-sm">
                        {workspace.name}
                      </span>
                      <span className="text-sm truncate max-w-44">
                        {workspace.address || "No Address"}
                      </span>
                    </div>
                  </div>
                  {workspace.active && (
                    <span
                      className={`truncate text-sm font-normal flex items-center gap-1 text-theme`}
                    >
                      <div className={"w-2 h-2 rounded-full bg-green-600"} />
                      Active
                    </span>
                  )}
                </div>
              </Dropdown.Item>
            );
          })}
        </div>
        <div>
          <div className="min-w-full px-4">
            <div
              className={
                "flex justify-between items-center w-full  gap-2 p-2 hover:bg-transparent"
              }
            >
              <div className={"flex items-center gap-2 "}>
                <div className="flex flex-col text-left text-theme w-60">
                  <span className="font-bold text-sm"> {user.name}</span>
                  {role === _userRole.STUDENT ? (
                    <span className="flex flex-row gap-2">
                      {user?.user_info?.active_class?.class?.name} (
                      {user?.user_info?.active_class?.section?.name}) |{" "}
                      {user?.user_info?.active_class?.roll_no}
                    </span>
                  ) : role === _userRole.STAFF ? (
                    <span className="flex flex-row gap-2">
                      {user?.user_info?.designation?.name} |{" "}
                      {user?.user_info?.designation?.department?.name}
                    </span>
                  ) : (
                    <span>WorkSpace Admin</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={"flex flex-col text-theme"}>
          <div
            className={
              "h-10 flex justify-between items-center border-t px-6 border-gray-200 "
            }
          >
            Active Session
            <div className={"flex items-center font-medium"}>
              {workspaceInfo?.default_workspace?.active_session?.name}
            </div>
          </div>
          <Dropdown.Item
            onClick={handleChangePassword}
            className={
              "h-10 flex text-theme justify-between items-center border-t px-6 border-gray-200 cursor-pointer"
            }
          >
            Change Password
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => handleClick()}
            className={` ${role !== _userRole.WORKSPACE_ADMIN
              ? "hidden"
              : "h-10 flex text-theme justify-between px-6 items-center border-t border-gray-200  cursor-pointer "
              }`}
          >
            Configuration Setup
            </Dropdown.Item>
          {loading ?
            <div
              className={
                "h-10 flex gap-1 items-center border-t border-gray-200 px-6 cursor-pointer"
              }
            >
              <AiOutlineLoading3Quarters className="animate-spin" />
            </div>
            :
            <div
              onClick={handleLogout}
              className={
                "h-10 flex gap-1 items-center border-t border-gray-200 px-6 text-red-600 cursor-pointer"
              }
            >
              Sign out
              <RiLogoutCircleRLine />
            </div>}
        </div>
      </div>
    </Dropdown>
  );
}
